import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=10a8d1dd&scoped=true&"
import script from "./brandList.vue?vue&type=script&lang=js&"
export * from "./brandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a8d1dd",
  null
  
)

component.options.__file = "src/demo/packageMall/brandList.vue"
export default component.exports